import React, { Component } from 'react';
import { Modal, Button, Form, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { modalActionCreator } from '../../store/actions/modalActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faCheck, faPen, faChevronCircleRight, faTimesCircle } from '@fortawesome/free-solid-svg-icons'


class importPastedCodingEventsModal extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            pastedData: "",
            processedData: [],
            customers: [],
            selectedCustomerId: null,
            selectedContactId: null,
            selectedLineOfBusinessId: null,
            importedData: [],
            columnLabels: [],
        };

        this.handleCopyPaste = this.handleCopyPaste.bind(this);
        this.hideModal = this.hideModal.bind(this);
        this.handleRemoveColumn = this.handleRemoveColumn.bind(this);
        this.handleRemoveRow = this.handleRemoveRow.bind(this);
        this.handleUserInput = this.handleUserInput.bind(this);
        this.prepareDataAndProcess = this.prepareDataAndProcess.bind(this);
    }

    handleUserInput(event) {
        // taken straight from the React Docs
        // https://reactjs.org/docs/forms.html#handling-multiple-inputs
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({ [name]: value });
    }
    //handleUserIntInput(event) {
    //    // taken straight from the React Docs
    //    // https://reactjs.org/docs/forms.html#handling-multiple-inputs
    //    const target = event.target;
    //    const name = target.name;
    //    let value = target.value === null || target.value === "0" ? null : parseInt(target.value);
    //    this.setState({ [name]: target.value });
    //}

    handleCopyPaste(event) {
        const target = event.target;
        let pastedData = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        
        this.setState({ pastedData: pastedData }, () => this.processPastedData(pastedData));

    }

    processPastedData() {
        const pastedData = this.state.pastedData;
        const rows = pastedData.split(/\r?\n/);
        const values = [];
        rows.forEach(row => {
            const col = row.split(/\t/);
            if (col.length > 0 && col[0] !== "") {
                values.push(col);
            }
        });
        let columnLabels = [];
        let isValidEventImportData = false;
        if (this.state.firstRowContainsColumns) {
            // split off the first one
            columnLabels = this.props.getColumnLabels(values);
            isValidEventImportData = this.props.checkIfValidImportData(columnLabels);
        } else {
            let widestCol = 0;
            values.forEach((row) => {
                const tempLen = Object.values(row).length;
                widestCol = tempLen > widestCol ? tempLen : widestCol;
            });

            for (let i = 1; i <= widestCol; i++) {
                columnLabels.push("Col " + i);
            }

        }
        this.setState({ importedData: values, columnLabels: columnLabels, isValidEventImportData: isValidEventImportData });
    }

    prepareDataAndProcess() {
        let data = [];
        if (this.state.isValidEventImportData) {
            data = this.state.importedData;
        } else {
            let tmpData = this.state.importedData;
            tmpData.forEach((row) => {
                const tmpRow = [];
                tmpRow.push("");
                tmpRow.push(row.join());
                tmpRow.push("");
                tmpRow.push("");
                tmpRow.push("");
                tmpRow.push("");
                data.push(tmpRow);
            });
        }

        this.props.buildEventPocoArray(this.state.columnLabels, data);
        this.props.hideModal();
    }

    handleRemoveRow(rowId) {
        let rows = [...this.state.importedData];

        rows.splice(rowId, 1);

        this.setState({ importedData: rows });

    }

    handleRemoveColumn(colId) {
        let values = this.state.importedData;
        let columnLabels = this.state.columnLabels;

        values.forEach((row) => {
            row.splice(colId, 1);
        })
        columnLabels.splice(colId, 1);
        this.setState({ importedData: values, columnLabels: columnLabels });

    }

    hideModal = () => {
        // need to check to make sure they want to cancel?
        this.props.hideModel();
    }

    render() {
        return (
            <>
                <Modal.Header>{this.props.title}</Modal.Header>
                <Modal.Body>
                    <Form.Row>
                        <Form.Group>
                            <Form.Label>Import by copy/paste</Form.Label>
                            <Form.Check type="checkbox"
                                label="First row contains column names"
                                name="firstRowContainsColumns"
                                id="firstRowContainsColumns"
                                className="mb-1"
                                checked={this.state.firstRowContainsColumns}
                                onChange={this.handleUserInput} />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} lg="12" md="12">
                            <Form.Control as="textarea"
                                rows="10"
                                placeholder="Copy your data from another document and paste it here."
                                name="copyPasteData"
                                onChange={this.handleCopyPaste} />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group>
                            <Form.Label>Pending import data</Form.Label>
                            <table className="table table-responsive">
                                <tr>
                                    <th>#</th>
                                    {
                                        this.state.columnLabels.map((label, idx) => {
                                            return <th className="flex align-items-center justify-content-center">{label}
                                                <FontAwesomeIcon
                                                    icon={faTimesCircle}
                                                    onClick={() => this.handleRemoveColumn(idx)}
                                                    className="text-danger float-right givemethefinger ml-3" />
                                            </th>
                                        })
                                    }
                                    <th>
                                    </th>
                                </tr>
                                {
                                    //this.state.copyPasteData
                                    this.state.importedData.map((row, idx) => {
                                        return (
                                            <tr>
                                                <td>{idx}</td>
                                                {
                                                    row.map((col) => {
                                                        return <td>{col}</td>
                                                    })
                                                }
                                                <td>

                                                    <FontAwesomeIcon
                                                        icon={faTimesCircle}
                                                        onClick={() => this.handleRemoveRow(idx)}
                                                        className="text-danger givemethefinger" />
                                                </td>
                                            </tr>
                                        );
                                    })
                                }
                                
                            </table>
                        </Form.Group>
                    </Form.Row>
                    {this.state.isValidEventImportData}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.props.hideModal}>Cancel</Button>
                    <Button variant="primary" onClick={this.prepareDataAndProcess}>Process</Button>
                </Modal.Footer>
            </>
        )
    }
}

export default importPastedCodingEventsModal